import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Use text-base (16px) on mobile to prevent iOS auto-zoom on focus
          'flex h-11 w-full rounded-xl bg-input px-4 py-2.5 text-base sm:text-sm text-foreground transition-all duration-200',
          'border border-input-border',
          'placeholder:text-muted-foreground',
          'hover:border-border-hover',
          'focus:outline-none focus:border-ring/50 focus:ring-4 focus:ring-ring/10',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          // Hide number input spinners — stepping by 0.01 is useless for prices/quantities.
          // Scoped to type=number: appearance:textfield on date inputs breaks the native picker.
          type === 'number' &&
            '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
          // iOS WebKit draws a date/time input as a native control and forces it to
          // content-box (even over border-box !important), so w-full plus padding and
          // border ran 34px past its container and h-11 grew to 66px (BUG-66).
          // appearance:none gives the box back. Scoped to iOS by -webkit-touch-callout;
          // the value is left-aligned because without the native appearance iOS centres it.
          (type === 'date' || type === 'time' || type === 'datetime-local' || type === 'month') &&
            'supports-[-webkit-touch-callout:none]:appearance-none [&::-webkit-date-and-time-value]:text-left',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
